// components/filter/priority-filter/priority-filter.component.jsx
// components/filter/priority-filter/priority-filter.component.jsx
import React from "react";
import { useDispatch } from "react-redux";
import { FaSeedling } from "react-icons/fa";

import { toggleStatus } from "../../../redux/filter/filter.actions";
import Tooltip from "../../retro/tooltip/tooltip.component";

import "./priority-filter.styles.scss";

const PriorityFilter = ({ priority, selected, scope }) => {
  const { name, value, color } = priority;
  const dispatch = useDispatch();

  return (
    <div
      onClick={() => dispatch(toggleStatus(value, scope))}
      className={`firePriority ${
        selected ? "firePriority__active" : ""
      }`}
    >
      <div className="firePriority-item" style={{ color }}>
        <Tooltip text={name} />

        <FaSeedling
          style={{
            opacity: selected ? 1 : 0.8,
            transform: selected ? "scale(1.15)" : "scale(1)",
          }}
        />

        {selected && (
          <div className="firePriority__active-name">
            <p>{name}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PriorityFilter;